module.exports = __webpack_public_path__ + "fonts/ClickerScript-Regular.fccb466b.ttf";